import React from 'react';

import BoxAgendamento from '@/features/recursos/agendamentos/BoxAgendamento';
import { FhirArtefatoType } from '@/features/enterprise/models/types';
import { groupBy } from '@/utils/collections';

import CategoriaArtefato from '../../CategoriaArtefato';
import { Content, Wrapper } from './styles';

interface ListaAgendamentosDefaultProps {
  agendamentos: FhirArtefatoType[];
}

const ListaAgendamentosDefault: React.FC<ListaAgendamentosDefaultProps> = ({
  agendamentos,
}) => {
  const agendamentosHasCategorias = React.useMemo(() => {
    return (
      agendamentos.filter(agendamento => !!agendamento.categoria).length > 0
    );
  }, [agendamentos]);

  const categoriaContent = React.useMemo(() => {
    const groupedArtefatos = groupBy(
      agendamentos,
      option => option.categoria || 'Outros',
    );

    return Object.entries(groupedArtefatos).map(([key, value]) => (
      <CategoriaArtefato
        key={key}
        name={key}
        artefatos={value.map(agendamento => (
          <BoxAgendamento
            key={agendamento.id.toString()}
            agendamento={(agendamento.pedido as unknown) as fhir4.Appointment}
          />
        ))}
      />
    ));
  }, [agendamentos]);

  return (
    <Wrapper>
      <Content>
        {agendamentosHasCategorias ? (
          <>{categoriaContent}</>
        ) : (
          <>
            {agendamentos.map(agendamento => (
              <BoxAgendamento
                key={agendamento.id.toString()}
                agendamento={
                  (agendamento.pedido as unknown) as fhir4.Appointment
                }
              />
            ))}
          </>
        )}
      </Content>
    </Wrapper>
  );
};

export default ListaAgendamentosDefault;
